import React, { useState } from 'react';
import { SuccessButton } from 'components/button';
import LargePopup from 'components/popup/large-popup';
import styled from 'styled-components';
import useFlashToggler from 'hooks/use-flash-toggler';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { useForm } from 'react-hook-form';
import { ClickableSpan } from 'views/common-styled-components';
import { PAYMENT_MODE } from 'constants/payment-modes';
import UserBankInfoSlab from 'views/payment-flow/user-bank-info-slab';
import callBtn from "images/call-expert.svg";
import { CommonStyledComponentProps } from '__utils/type';
import { isProUser } from '__utils/common-utils';

interface PaymentModeSelectionProps {
    onClose?: any;
    totalCartInvestmentAmount: number;
    onSelectPaymentMode: (paymentMode: string) => void;
}

const PaymentModeSelectionOuterCont = styled.div<CommonStyledComponentProps>`
    h3{
    color: #212121;
    border-bottom: solid 1px #e0e0e0;
    padding: 24px;
    font-size: 18px;
    font-weight: 400;
    }
   
    .footer {
        background: #fff;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 8px;
        box-shadow: 0 2px 4px 4px ${COLOR.LIGHTGREY};
        z-index: 1050;
    }
    .Custradio em{
        font-weight: 500;
        margin-left: 15px;
    }
    section{
        padding-top: ${(props: CommonStyledComponentProps) => props.isMobile ? isProUser() ? `0` : `48px` : ``};
        height:  ${(props: CommonStyledComponentProps) => props.isMobile ? `100vh` : `auto`}; 
        overflow: 'hidden';
    }
    .pb16{
        padding-bottom: 16px;
    }
    .ulSection{
        padding: 16px;
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? `16px` : `16px 60px`};

    }
`;
const DesktopSubmitButton = styled(SuccessButton)`
        width: 40%;
	    margin: 20px auto;
        display: block;
        text-align: center;
	    height: 40px;
	    border-radius: 4px;

`;

const PaymentModeSelection: React.FC<PaymentModeSelectionProps> = (props: PaymentModeSelectionProps) => {
    
    const flash = useFlashToggler();
    const [ showChequePaymentDetails, setShowChequePaymentDetails ] = useState<boolean>(false);
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { register, handleSubmit } = useForm({ mode: 'onChange' });

    const getChequeMessage = () => {
        return props.totalCartInvestmentAmount > 200000 ? "You will get NAV of the day when cheque gets cleared." : "NAV will be allocated as per the day when cheque gets cleared.";
    }

    const onPaymentModeContinue = (data: any) => {
        if (!data.paymentMode)
        {
            flash.error("Please select investment mode.");
        } else
        {
            props.onSelectPaymentMode(data);
        }
    }

    return <LargePopup
        modalWidth= '620px'
        onClose={ props?.onClose }
        headerContent={
            <div style={ { fontSize: "16px", display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                <div>
                    <i className="icon-Back headerIconSet" style={ { fontSize: "22px", marginRight: "10px", lineHeight: "1.5" } }
                        onClick={ () => props?.onClose() }>
                    </i>
                    <span style={ { lineHeight: "2.1", fontSize: "16px" } }>Mode of Payment
                    </span>
                </div>
                <div>
                    <a href="tel:18002666468" style={ { marginRight: '6px' } }><img src={ callBtn } alt="call expert" /></a>

                </div>
            </div> }
        closable={ true }
        showBacktoHome
    >
        <PaymentModeSelectionOuterCont isMobile={isMobile}>
            { !isMobile && <h3 className="class-h3">Payment Mode</h3> }
            <div className={ isMobile ? "investment_container p16" : "investment_container " } >
                <section>
                    <div style={{paddingLeft: isMobile ? '' : '60px'}}>
                          <UserBankInfoSlab />
                    </div>
                  
                    
                    { <div className={ isMobile ? "mint-box mt15 mb16  p16" : "pb16" }>
                        <form name="paymentModeForm" onSubmit={ handleSubmit(onPaymentModeContinue) }>
                            <div className="px-card-no-padding">
                                <ul className="Custradio floatnone newCustradio ulSection" >
                                    <li className={ isMobile ? "floatnone w100 " : "floatnone w100 mb-25" } >
                                        <input
                                            name='paymentMode'
                                            type="radio"
                                            value={ PAYMENT_MODE.UPI }
                                            ref={register() }
                                        /><span></span>
                                        <em>UPI</em>
                                    </li>


                                    <li className={ isMobile ? "floatnone w100 " : "floatnone w100 mb-25" }>
                                        <input
                                            name='paymentMode'
                                            type="radio"
                                            value={ PAYMENT_MODE.NET_BANKING }
                                            ref={register() }
                                        /><span></span>
                                        <em>Net banking</em>
                                    </li>

                                    <li className="floatnone w100 ">
                                        <input
                                            name='paymentMode'
                                            type="radio"
                                            value={ PAYMENT_MODE.CHEQUE }
                                            ref={register() }
                                        /><span></span>
                                        <em>Cheque</em>
                                        <p>{ getChequeMessage() }</p>
                                    </li>

                                    <div style={ { padding: "0 10px 4px 35px", marginBottom: isMobile ? "0px" : "10px" } }>
                                        <ClickableSpan onClick={ () => setShowChequePaymentDetails(!showChequePaymentDetails) }>
                                            <span className="fw-300">Cheque payment details </span>
                                            { showChequePaymentDetails ? <i className="icon-arrow_up"></i> : <i className="icon-arrow_down"></i> }
                                        </ClickableSpan>
                                        { showChequePaymentDetails && <div style={ { marginTop: isMobile ? "6px" : "20px", lineHeight: "1.5" } } >A <b>single cheque</b> for the entire investment amount needs to be written in the name of <b>Indian Clearing Corporation Limited</b>.
                                            The cheque and the challan (to be generated in the next step) need to be <b>deposited at nearest Axis Bank branch.</b> </div> }
                                    </div><br />
                                    <li className={ isMobile ? "floatnone w100 " : "floatnone w100 mb-25" }>
                                        <input
                                            name='paymentMode'
                                            type="radio"
                                            value={ PAYMENT_MODE.NEFT }
                                            ref={register() }
                                        /><span></span>
                                        <em>NEFT / RTGS</em>

                                    </li>
                                    <li className="floatnone w100">
                                        <input
                                            name='paymentMode'
                                            type="radio"
                                            value={ PAYMENT_MODE.OTM }
                                            ref={register() }
                                        /><span></span>
                                        <em>One Time Mandate</em>
                                        <p>On the next page, please select One Time Mandate from the dropdown and select the Mandate ID that you want to use for payment.</p>
                                    </li>
                                </ul>
                            </div>
                            <div className={ isMobile ? "footer" : "" }>
                                { isMobile ? <SuccessButton type="submit">Initiate Payment</SuccessButton> : <DesktopSubmitButton type="submit">Initiate Payment</DesktopSubmitButton> }
                            </div>
                        </form>
                    </div> }
                </section>
            </div>
        </PaymentModeSelectionOuterCont>
    </LargePopup>
}

export default PaymentModeSelection;